import { render, staticRenderFns } from "./FormTableCertificates.vue?vue&type=template&id=8fa976a4&scoped=true&"
import script from "./FormTableCertificates.vue?vue&type=script&lang=js&"
export * from "./FormTableCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa976a4",
  null
  
)

export default component.exports